module.exports = __webpack_public_path__ + "static/media/Picture1.b31949d9.png";